import { DayOfWeek, TimeRangeOp } from '@/proto/logiblocks/logiblocks';

/** One entry's time-of-day filter. `allDay` means no filter — start/end are
 * meaningless and ignored when it's set. */
export interface EntryTimeWindow {
  allDay: boolean;
  /** Seconds since midnight, in the set's display timezone while editing. */
  startSeconds?: number;
  endSeconds?: number;
}

/** One selected calendar date with its own time window. */
export interface DateWindowEntry {
  /** 'YYYY-MM-DD', interpreted in the set's ianaTimezone. */
  date: string;
  window: EntryTimeWindow;
}

/** One selected day of the week with its own time window. */
export interface DayWindowEntry {
  day: DayOfWeek;
  window: EntryTimeWindow;
}

/** The entries of a date/day set — either dates or days of the week, never both. */
export type DateSetEntries =
  | { kind: 'dates'; entries: DateWindowEntry[] }
  | { kind: 'daysOfWeek'; entries: DayWindowEntry[] };

/** The in-memory editing model for a condition's date/time value, before
 * it's serialized to a DateTimeSetExpr proto or a SavedDateList payload. */
export interface DateSetValue {
  entries: DateSetEntries;
  ianaTimezone: string;
  operator: TimeRangeOp;
}

/** The time window meaning "no time-of-day filter". */
export const ALL_DAY_WINDOW: EntryTimeWindow = { allDay: true };

/** Every day of the week, Sunday first (the DayOfWeek enum order). */
export const ALL_DAYS: DayOfWeek[] = [
  DayOfWeek.SUNDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
];
